import moment from "moment";

export default {
  computed: {
    currentYearNum() {
      return Number.parseInt(moment().format("YYYY"), 10);
    },
    currentMonthNum() {
      return Number.parseInt(moment().format("M"), 10);
    },
    monthsWithDisabled() {
      const y = Number.parseInt(this.yearSelected, 10);
      const currentYear = Number(this.currentYearNum);

      return this.months.map((m) => {
        if (y === currentYear) {
          return { ...m, $isDisabled: m.id >= this.currentMonthNum };
        }
        if (y < currentYear) {
          return { ...m, $isDisabled: false };
        }
        return { ...m, $isDisabled: true };
      });
    },
  },
};